<template>
  <Dropdown
    @command="command => handleDropdownAction(command)"
    @visible-change="handleDropdownToggle"
    trigger="click"
    :class="showInDrawer && 'dropdown--show-in-drawer'"
  >
    <template v-if="showInDrawer">
      <UserNavigationLinks
        :show-in-drawer="showInDrawer"
        @handle-drawer-toggle="handleDrawerToggle"
      />
    </template>
    <template v-else>
      <Button
        class="navigation__button navigation_button--only-icon dropdown-toggle"
        data-test="my_account"
        type="text"
        icon="icon icon-user"
        is-navbar-button
      >
        {{ $t('header.myAccount') }}
      </Button>
      <DropdownMenu slot="dropdown">
        <UserNavigationLinks />
      </DropdownMenu>
    </template>
  </Dropdown>
</template>

<script>
import { PATH_INVOICE } from '~/router';
import UserNavigationLinks from './UserNavigationLinks.vue';

export default {
  components: {
    UserNavigationLinks,
  },
  props: {
    showInDrawer: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dropdownIsOpen: false,
  }),
  methods: {
    handleDropdownAction(action) {
      if (action?.name !== undefined) {
        this.$router.push({
          name: action.name,
        });
      }

      switch (action) {
        case 'logout':
          if (this.showInDrawer) {
            this.handleLogoutClick();
          }
          this.$store.dispatch('auth/signOut').finally(() => {
            this.$router.push({ name: PATH_INVOICE });
          });

          break;
        case 'showEetDialog':
          this.$store.dispatch('eetForm/openEetDialog');
          break;
        case 'showGeneralSettings':
          this.$store.dispatch('settingsForm/openSettingsDialog', { type: 'generalSettingsForm' });
          break;
        case 'showEmailsSettings':
          this.$store.dispatch('settingsForm/openSettingsDialog', { type: 'emailsForm' });
          break;
        case 'showPasswordSettings':
          this.$store.dispatch('settingsForm/openSettingsDialog', { type: 'passwordForm' });
          break;
        case 'showBillingSettings':
          this.$store.dispatch('settingsForm/openSettingsDialog', { type: 'billingForm' });
          break;
        case 'showSequencesSettings':
          this.$store.dispatch('settingsForm/openSettingsDialog', { type: 'sequencesForm' });
          break;
        case 'showUsersPermitionsSettings':
          this.$store.dispatch('settingsForm/openSettingsDialog', { type: 'usersList' });
          break;
        default:
          break;
      }
    },
    handleDropdownToggle(val) {
      this.dropdownIsOpen = val;
    },
    handleDrawerToggle() {
      this.$emit('handle-drawer-toggle');
    },
    handleLogoutClick() {
      this.$emit('handle-logout-click');
    },
  },
};
</script>

<style lang="scss" scoped>
.navigation_button--only-icon {
  @media only screen and (max-width: $--new-navbar-breakpoint) {
    min-height: 2.5rem;
    min-width: 3rem;

    :deep() {
      .icon + span {
        display: none;
      }
    }
  }
}

.dropdown--show-in-drawer {
  width: 100%;
  padding-top: 8px;
}
</style>
